import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'math-equal-greater', 'MathEqualGreater', [["path",{"d":"M5 18l14 -4"}],["path",{"d":"M5 14l14 -4l-14 -4"}]]);